import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  routeData: { title: string; color: string; icon: string; } = {} as any;
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.subscription = new Subscription();
  }

  @Input() sideNavRef: MatSidenav = {} as MatSidenav;

  // getActivePageOnEnter() {
  //   this.routeData = { ...this.activatedRoute.snapshot.firstChild.firstChild.firstChild.data } as any;
  // }

  getActivePage() {
    // this.subscription.add(
    //   this.router.events
    //     .pipe(
    //       filter(event => event instanceof NavigationEnd),
    //       map(() => this.activatedRoute.snapshot.firstChild.firstChild.firstChild.data),
    //     )
    //     .subscribe((routeData: any) => {
    //       this.routeData = routeData;
    //     })
    // );
  }

  toggleSideNav() {
    this.sideNavRef.toggle();
  }

  ngOnInit() {
    // this.getActivePageOnEnter();
    // this.getActivePage();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
